// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__rmlgf","selects":"Documents_selects__Ajh30"};